export class RenderData {
  width: number;
  position = 0;

  constructor(width?: number) {
    this.width = width ? width : 0;
  }
}
